import { Container, AppBar, Toolbar, Typography, IconButton, Snackbar, Box } from '@mui/material';
import { AddOutlined, ArrowBackOutlined, DeleteOutline, RemoveOutlined } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { toReal, createNewTheme, extrairValor } from '../functions/utils';

import * as React from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '@fontsource/roboto/400.css';
import { SpacerGustio } from '../components/DesignSystem/SpacerGustio';
import { ButtonGustio } from '../components/DesignSystem/ButtonGustio';

function Carrinho() {

  const state = useLocation().state;
  const page = state ? state.page : 'home';
  const [colorPrimary, setColorPrimary] = useState(state ? state.colorPrimary : "217, 217, 217");
  const [colorSecondary, setColorSecondary] = useState(state ? state.colorSecondary : "217, 217, 217");
  const [colorTertiary, setColorTertiary] = useState(state ? state.colorTertiary : "217, 217, 217");
  const [carrinho, setCarrinho] = useState([]);
  const [urlBase, setUrlBase] = useState("");
  const [valorTotalCarrinho, setValorTotalCarrinho] = useState("");
  const [openSnack, setOpenSnack] = useState(false);
  const [msgSnack, setMsgSnack] = useState(false);
  const navigate = useNavigate();

  const handleBack = () => {
    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      navigate(`/?nm=${btoa(numeroMesa)}`, { replace: true, state: { page: page } })
    } else {
      navigate("/", { replace: true, state: { page: page } })
    }
  };
  
  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      handleBack();
    };

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleSnack = (title) => {
    setMsgSnack(title);
    setOpenSnack(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const handleClear = () => {
    localStorage.removeItem('crU');
    localStorage.removeItem('bCrt');
    localStorage.removeItem('vPt');
    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      navigate(`/?nm=${btoa(numeroMesa)}`, { replace: true, state: { page: page } })
    } else {
      navigate("/", { replace: true, state: { page: page } })
    }
  };

  const handleEnderecos = () => {
    const valorMinimo = localStorage.getItem('vlMnm');
    const val = extrairValor(valorMinimo);
    if(valorMinimo && val !== "0,00") {
      const valor1 = parseFloat(valorTotalCarrinho.replaceAll(".", "").replaceAll(",", '.'))
      const valor2 = parseFloat(val.replaceAll(".", "").replaceAll(",", '.'))
      if(valor2 > valor1) {
        handleSnack(`O valor minimo de compra no estabelecimento é de R$ ${toReal(valor2)}`);
        return
      }
    }

    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      localStorage.setItem('tE', 1);
      localStorage.setItem('fmP', "mesa");
      navigate("/finalizar", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
    } else {
      navigate("/enderecos", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
    }
  };

  const handleAddQtd = (id) => {
    let bloquearCarrinho = localStorage.getItem('bCrt');
    if (bloquearCarrinho) {
      return;
    }

    for (const produto of carrinho) {
      if (produto.id === id) {
        const newValue = produto.quantidade + 1
        if (produto.limiteestoque && newValue > parseInt(produto.limiteestoque)) {
          handleSnack(`Só existe apenas ${produto.limiteestoque} em estoque.`)
          return
        }
        produto.quantidade += 1
        produto.valorTotal = toReal(parseFloat(produto.valorComAdicionais.replaceAll(".", "").replaceAll(",", '.')) * produto.quantidade)
      }
    }
    localStorage.setItem('crU', btoa(JSON.stringify(carrinho)));
    updateCart();
  };

  const handleRmQtd = (id) => {
    let count = 0
    for (const produto of carrinho) {
      if (produto.id === id) {
        if (produto.quantidade === 1) {
          carrinho.splice(count, 1);
          continue
        }
        produto.quantidade -= 1
        produto.valorTotal = toReal(parseFloat(produto.valorComAdicionais.replaceAll(".", "").replaceAll(",", '.')) * produto.quantidade)
      }
      count++
    }
    let bloquearCarrinho = localStorage.getItem('bCrt');
    if (bloquearCarrinho) {
      handleClear();
    }
    localStorage.setItem('crU', btoa(JSON.stringify(carrinho)));
    updateCart();
  };

  useEffect(() => {

    const mainName = localStorage.getItem('Mn');
    document.title = mainName;
    const urlBase = localStorage.getItem('UBs');
    const favicon = document.querySelector('link[rel="icon"]');
    favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store-${localStorage.getItem("Md")}.png?${new Date().getTime()}`;

    if (colorPrimary) {
      setColorPrimary(localStorage.getItem("clPmr"))
      setColorSecondary(localStorage.getItem("clScr"))
      setColorTertiary(localStorage.getItem("clTcr"))
    }

    const url = localStorage.getItem('UBs');
    setUrlBase(url);
    updateCart();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateCart = () => {
    let currentCarrinho = localStorage.getItem('crU');
    if (currentCarrinho) {
      currentCarrinho = JSON.parse(atob(currentCarrinho))
      let valorTotal = 0
      setCarrinho(currentCarrinho)
      for (const produto of currentCarrinho) {
        valorTotal += parseFloat(produto.valorTotal.replaceAll(".", "").replaceAll(",", '.'))
      }
      let bloquearCarrinho = localStorage.getItem('bCrt');
      if (valorTotal === 0 && !bloquearCarrinho && localStorage.getItem("vPt")) {
        localStorage.removeItem('crU');
        handleBack()
      }
      localStorage.setItem('vlT', toReal(valorTotal));
      setValorTotalCarrinho(toReal(valorTotal))
    }
    if (currentCarrinho && currentCarrinho.length === 0) {
      localStorage.removeItem('crU');
      handleBack()
    }
  }

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <Container>
        <AppBar position="absolute" style={{ backgroundColor: `rgba(${colorPrimary})`, color: "#FFF", fontWeight: "bold", boxShadow: "none", fontFamily: "roboto" }}>
          <Toolbar>
            <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} style={{ color: "#FFF" }} onClick={handleBack}>
              <ArrowBackOutlined />
            </IconButton>
            Sacola
            <ButtonGustio fullWidth={false} variant="text" style={{ marginLeft: "auto", color: "white" }} onClick={handleClear}>Limpar</ButtonGustio>
          </Toolbar>
        </AppBar>

        <Snackbar
          open={openSnack}
          autoHideDuration={3000}
          onClose={handleClose}
          message={msgSnack}
          style={{ zIndex: "10001" }}
        />

        <SpacerGustio height={80} />

        <ButtonGustio variant="text" fullWidth={false} startIcon={<AddOutlined />} onClick={handleBack}>
          Adicionar mais itens
        </ButtonGustio>

       <SpacerGustio height={8} />

        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
          {carrinho.map((produto) => (
            <>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <img alt="produto" src={`${urlBase.replaceAll("/api", "")}/imagens-produtos/${produto.id}_0.png?${new Date().getTime()}`} style={{ borderRadius: "4px", height: "56px", width: "56px" }} onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "https://gustio.com.br/imagens/placeholder.png";
                  }} />
                </ListItemAvatar>
                <ListItemText
                  primary={produto.nome}
                  primaryTypographyProps={{ fontSize: "16px", color: "#1B1B1B", fontWeight: "bold", paddingLeft: "16px" }}
                  secondary={
                    <React.Fragment>
                      <Typography sx={{ fontSize: "14px", color: "#999", paddingLeft: "16px" }}>
                        {produto.descricao}
                        {(produto.adicionais).map((adicional) => (
                          <>
                            <b style={{ fontSize: "12px" }}><br />+ {adicional.quantidadeOpcional}x {adicional.nomeOpcional}</b>
                          </>
                        ))}
                      </Typography>
                    </React.Fragment>
                  }
                />

              </ListItem>
              <Box style={{ backgroundColor: "white", padding: "16px", display: "flex", alignItems: "center" }}>
                <Typography style={{ float: "left", fontSize: "16px", fontWeight: "bold", color: `rgba(${colorPrimary})` }}>
                  {produto.valorTotal === "0,00" && localStorage.getItem("vPt") ? (
                    <>
                      Resgate
                    </>
                  ) : (
                    <>
                      {produto.valorTotal === "0,00" || produto.valorTotal === 0 ?
                        <>A Consultar</>
                        :
                        <> R$ {produto.valorTotal} </>
                      }
                    </>
                  )}
                </Typography>

                <Box style={{ position: "absolute", right: "16px", backgroundColor: "white", padding: "5px", border: "solid #DCDBDB 1px", borderRadius: "8px", width: "131px", height: "40px", display: "flex", alignItems: "center" }}>
                  <p style={{ position: "absolute", right: "0", left: "0", textAlign: "center", fontFamily: "roboto", fontWeight: "700" }}>{produto.quantidade}</p>
                  {produto.quantidade === 1 ? (
                    <DeleteOutline style={{ position: "absolute", left: "16px", color: "#464545" }} onClick={() => handleRmQtd(produto.id)} />
                  ) : (
                    <RemoveOutlined style={{ position: "absolute", left: "16px", color: "#464545" }} onClick={() => handleRmQtd(produto.id)} />
                  )}
                  <AddOutlined style={{ position: "absolute", right: "16px", color: "#464545" }} onClick={() => handleAddQtd(produto.id)} />
                </Box>
              </Box>
            </>
          ))}
        </List>

        <Box style={{ borderTop: `solid 1px rgba(${colorPrimary})`, position: "fixed", bottom: "0", right: "0", left: "0", backgroundColor: "white", padding: "16px 16px 16px 16px" }}>
          <Typography style={{ float: "left", fontSize: "14px", fontWeight: "bold", paddingLeft: "16px" }}>
            Total
          </Typography>
          <Typography style={{ float: "right", fontSize: "16px", fontWeight: "bold", color: `rgba(${colorPrimary})` }}>
            {valorTotalCarrinho === "0" && localStorage.getItem("vPt") ? (
              <>
                Resgate
              </>
            ) : (
              <>
                {valorTotalCarrinho === "0,00" || valorTotalCarrinho === 0 ?
                  <>A Consultar</>
                  :
                  <> R$ {valorTotalCarrinho} </>
                }
              </>
            )}
          </Typography>
          <SpacerGustio height={35} />
          <ButtonGustio onClick={handleEnderecos}>
            Continuar
          </ButtonGustio>
        </Box>
        <SpacerGustio height={200} />

      </Container>
    </ThemeProvider>
  );
}

export default Carrinho;